/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var DataType;
(function (DataType) {
    DataType["Integer"] = "INTEGER";
    DataType["Decimal"] = "DECIMAL";
})(DataType || (DataType = {}));
export function DataTypeFromJSON(json) {
    return DataTypeFromJSONTyped(json, false);
}
export function DataTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DataTypeToJSON(value) {
    return value;
}
